import { COLOR, FONT_SIZE, FONT_WEIGHT } from "@dmm-com/rocket-web-ui-library";
import styled from "@emotion/styled";

export const DivContainer = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 8px;
  font-size: ${FONT_SIZE.M}px;
`;

export const DivPointContainer = styled.div`
  @media (any-hover: hover) {
    :hover {
      cursor: pointer;
    }
  }
`;

export const ParContentsHead = styled.p`
  font-size: ${FONT_SIZE.XS}px;
`;

export const ParContentsValue = styled.p`
  font-size: ${FONT_SIZE.XS}px;
  > span {
    font-size: ${FONT_SIZE.S}px;
    font-weight: ${FONT_WEIGHT.BOLD};
  }
`;

export const DivWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

export const ButtonIconWrapper = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background-color: ${COLOR.GRAY900.code};
`;
